import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1ca41ce4"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]


import { BrushMapAddedBrushes } from '@/pages/BrushMapPage/brushMapAddedBrushes'
import { SelectedBrushType } from '@/shared/types'

interface Props {
  list: SelectedBrushType[]
  firstPosition: number
  secondPosition: number
  brushMapBrushes: BrushMapAddedBrushes
}


export default /*#__PURE__*/_defineComponent({
  props: {
    list: null,
    firstPosition: null,
    secondPosition: null,
    brushMapBrushes: null
  },
  setup(__props: any) {

const props = __props as {
  list: SelectedBrushType[]
  firstPosition: number
  secondPosition: number
  brushMapBrushes: BrushMapAddedBrushes
}



function selectNewBrush(brush: SelectedBrushType) {
  props.brushMapBrushes.selectedBrush = brush
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.list.slice(__props.firstPosition, __props.secondPosition), (brush) => {
    return (_openBlock(), _createElementBlock("li", {
      class: "colors__item",
      onClick: ($event: any) => (selectNewBrush(brush))
    }, [
      _createElementVNode("div", {
        style: _normalizeStyle({ background: brush.color }),
        class: "colors__circle"
      }, null, 4),
      _createElementVNode("span", null, _toDisplayString(brush.colorName), 1)
    ], 8, _hoisted_1))
  }), 256))
}
}

})